export default [
  {"id": 1, "title": "iPad 4 Mini", "price": 500.01, "in_basket": false},
  {"id": 2, "title": "H&M T-Shirt White", "price": 10.99, "in_basket": false},
  {"id": 3, "title": "Charli XCX - Sucker CD", "price": 19.99, "in_basket": false}
];



// WEBPACK FOOTER //
// src/client/test_data/basket/products.js